import type { ValuationToolEvent } from "@repo/analytics/lib/valuation-tool-events";
/** No email, answers, revenue, or credentials in funnel events. */
export function trackValuation(
  payload: NonNullable<ValuationToolEvent["payload"]>,
): void {
  void import("@repo/analytics/client")
    .then(({ analytics }) =>
      analytics.trackEvent({ event: "Valuation Tool Event", payload }),
    )
    .catch(() => undefined);
}
